<template>
  <form @submit.prevent="submitForm">
    <div class="row q-mb-md">
      <q-input
        v-model="formData.otp"
        type="number"
        ref="otp"
        lazy-rules
        outlined
        class="col"
        label="OTP" />
    </div>
    <div class="row">
      <q-btn
        class="full-width"
        color="primary"
        label="ลงทะเบียน"
        type="submit">
          <template v-slot:loading>
            <q-spinner-facebook />
          </template>
      </q-btn>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import axios from 'axios'
export default {
  data () {
    return {
      formData: {
        otp: '',
        line_id: ''
      }
    }
  },
  methods: {
    ...mapActions('auth', ['registerUser', 'setProfile']),
    submitForm () {
      this.registerUser(this.formData)
    },
    registerUser () {
      // console.log(this.line)
      this.formData.line_id = this.line.userId
      axios.put(`${process.env.VUE_APP_API}api/line`, { ...this.formData, ...this.line })
        .then((res) => {
          if (res.data != null) {
            // console.log(res.data)
            if (this.activeRoute !== null) {
              this.$router.push(this.activeRoute, () => {})
            } else {
              this.$router.push('/dashboard', () => {})
            }
          }
        })
        .catch(e => {
          if (e.response.status === 401) {
            // console.log(e.response.status)
            this.$router.push('/register', () => {})
          }
        })
    }
  },
  computed: {
    ...mapState('auth', ['line', 'activeRoute'])
  }
}
</script>

<style lang="scss" scoped>

</style>
